import { render, staticRenderFns } from "./mainmenu.vue?vue&type=template&id=3b9d20b6&scoped=true"
import script from "./mainmenu.vue?vue&type=script&lang=js"
export * from "./mainmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9d20b6",
  null
  
)

export default component.exports